export const nextTokenTopicName = name => `nextToken.${name}`;
export class TokenService {
  constructor(mailBox) {
    this.mailBox = mailBox;
    // Configuration provided by the application
    this.tokenLogicEntries = {};
    // Tracker for whether the first token has come in for the named token logic provider
    this.tokenProvided = {};
    // Components waiting on tokens
    this.waitSlips = [];
    this.consumerClient = mailBox.buildConsumerClient("tokenService");
  }
  offerTokenLogic(tokenLogic) {
    if (this.tokenLogicEntries[tokenLogic.name]) {
      console.warn(`[MD] Token logic name conflict for ${tokenLogic.name}`);
      return;
    }
    this.tokenLogicEntries[tokenLogic.name] = tokenLogic;
    this.consumerClient.subscribeToTopic(nextTokenTopicName(tokenLogic.name), () => {
      this.tokenProvided[tokenLogic.name] = true;
      this.flushWaitSlips();
    }, true);
  }
  triggerPreFetch(names, context) {
    names.forEach(name => {
      var _a;
      return (_a = this.tokenLogicEntries[name]) === null || _a === void 0 ? void 0 : _a.triggerCallback(context);
    });
  }
  notify(name, nextToken) {
    this.mailBox.publish(nextTokenTopicName(name), {
      nextToken
    });
  }
  waitOn(names) {
    return new Promise(resolve => {
      // Resolve immediately if nothing is specified or we're already good to go
      if (!(names === null || names === void 0 ? void 0 : names.length) || names.every(n => this.tokenProvided[n])) {
        resolve();
        return;
      }
      // But if we're not, then we need to register a wait-slip
      // TODO: Introduce some level of timeout here, possibly application-configured
      this.waitSlips.push({
        readyCallback: () => resolve(),
        waitingOn: names.filter(n => !this.tokenProvided[n])
      });
    });
  }
  flushWaitSlips() {
    // Start by updating each slip and removing things we're no longer waiting on
    this.waitSlips.forEach(slip => slip.waitingOn = slip.waitingOn.filter(n => !this.tokenProvided[n]));
    // Then call the ready callback on any slip that's no longer waiting on anything
    this.waitSlips.filter(slip => slip.waitingOn.length === 0).forEach(slip => slip.readyCallback());
    // Finally, clear out all satisfied slips
    this.waitSlips = this.waitSlips.filter(slip => slip.waitingOn.length > 0);
  }
}